<template>
    <div class="DoRecord">
        <div class="main">
            <el-table :data="recordList" style="width: 100%">
                <el-table-column prop="taskname" label="试卷名称" width="300"></el-table-column>
                <el-table-column prop="factexamtime" label="答题时间（分钟）" align="center"></el-table-column>
                <el-table-column label="答题进度" align="center">
                    <template slot-scope="scope"><span>{{scope.row.answerquescount}}/{{scope.row.quescount}}</span></template>
                </el-table-column>
                <el-table-column label="操作" width="200px" align="right">
                    <template slot-scope="scope">
                        <span class="operationText" v-if="scope.row.status===1" @click="goExam(scope.row)">继续考试</span>
                        <div class="reExam" v-if="scope.row.status!==1">
                            <span class="operationText" v-if="scope.row.status!==1" @click="seeAchievement(scope.row)">查看成绩</span>
                            <span class="operationLine" v-if="scope.row.ismakeuptest===1">|</span>
                            <span class="operationText" v-if="scope.row.ismakeuptest===1" @click="goExam(scope.row)">重新考试</span>
                        </div>

                    </template>
                </el-table-column>
            </el-table>
            <div v-if="this.recordList.length > 0" class="page_box">
                <el-pagination background layout="prev, pager, next" :page-size="10" :total="totalPage"
                               @current-change="handleCurrentChange"></el-pagination>
            </div>
            <!--<el-pagination background layout="prev, pager, next" :current-page.sync='recordList.page'  @current-change="handleCurrentChange" :total="rowCount"> </el-pagination>-->
        </div>
    </div>
</template>

<script>
    import {getUserDoExamRecordList} from 'api/personalCenterApi'
    import $ from 'jquery'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: "DoRecord",
        data() {
            return {
                recordList: [],
                totalPage: 0,
            }
        },
        mounted() {
            this.getList(1)
        },
        methods: {
            getList(val) {
                this.setLoading(true);
                let params = {
                    page: val,
                    pageSize: 10
                };
                getUserDoExamRecordList({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        console.log(data)
                        this.recordList = data.data.content
                        this.totalPage = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        // console.log('error：', data)
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            handleCurrentChange() { // 翻页
                let clickPage = $(".el-pagination .active").html();
                this.getList(clickPage)
            },
            //继续考试/重新考试
            goExam(row){
                this.$router.push({name: 'ExaminationPaperInformation',query: {bankid:row.bankid,taskid: row.taskinnerid}})
            },
            //查看成绩
            seeAchievement(row){
                this.$router.push({name: 'ViewingResults',query: {examid:row.innerid}})
            },
            ...mapActions([
                'setLoading'
            ])
        },
        computed: {
            ...mapGetters([])
        },
    }
</script>

<style lang="scss" scoped>
    .DoRecord .center {
        text-align: center;
    }

    .DoRecord {
        .operationText {
            cursor: pointer;
            /*padding: 0 8px;*/
            &:hover {
                color: #409EFF;
            }
        }
        .reExam{
            .operationLine {
                color: #e5e5e5;
                padding: 0 8px;
            }
        }
    }
</style>